<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/en/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p style="margin-bottom : 40px; text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">User Guide</span></p>'
      + '<p style="margin-bottom : 20px"><span style="font-size: 16px;">We apply a user station mechanism, which allows research groups to conduct research in the facility as user stations with an execution period. NFTM provides each user station with customized supporting and service program.</span></p>'
      + '<p style="margin-bottom : 30px"><span style="margin-left: 30px; font-size: 16px;color: #033d80; ">▶ Application</span></p>'

      +'<p style="margin-bottom : 30px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/yhgzz1_en.jpg" style="width: 660px; margin-right: 16px;margin-bottom: 20px;" width="960px"  border="0" vspace="0" alt=""></p>'
      + '<p style="margin-bottom : 10px"><span style="margin-left: 30px; font-size: 16px;color: #033d80; ">▶ Termination</span></p>'
      + '<p style="margin-bottom : 30px; margin-left: 30px; "><span style="font-size: 16px;">At the end of the execution period, user stations  terminate automatically if no extension or renewal application is submitted to the User Affairs Division. </span></p>'
      + '<p style="margin-bottom : 10px"><span style="margin-left: 30px; font-size: 16px;color: #033d80; ">▶ Users Affairs Division</span></p>'
      + '<p style="margin-bottom : 0px; margin-left: 30px; "><span style="font-size: 15px;">Address：C4, Translational Medicine Building, Shanghai Jiao Tong University, 800 Dongchuan Road, Minhang District, Shanghai, P.R. China</span></p>'
      + '<p style="margin-bottom : 20px"><span style="margin-left: 30px; font-size: 16px;">Email：user.tm@sjtu.edu.cn</span></p>'

    //   + '<p style="margin-top:50px; text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">用户实验室</span></p>'
    // + '<p style="margin-bottom : 20px"><span style="margin-left: 36px; font-size: 16px;">转化医学闵行基地内规划了近 2 万平方米的用户共享实验室， 包括生物化学实验室 4 个，生物信息实验室 2 个，生物医学 制造实验室 3 个。</span></p>'
    //
    // +'<p style="margin-bottom : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/gxsys1.png" style="width: 780px; margin-right: 16px;margin-bottom: 16px;" width="960px"  border="0" vspace="0" alt=""></p>'
    //
    // + '<p style="margin-bottom : 0px"><span style="margin-left: 160px; font-size: 16px; ">▶  生物信息用户共享实验室</span></p>'
    // + '<p style="margin-bottom : 20px;margin-left: 160px; margin-right: 160px; font-size: 16px;">以支撑转化医学数据研究为主。高性能计算及存储能力由网络中心集中建设与运行管理，本类实验室主要提供使用终端所需办公环境。</p>'
    // +'<p style="margin-bottom : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/xwyxxx.jpg" style="width: 740px; margin-right: 16px;margin-bottom: 16px;" width="760px"  border="0" vspace="0" alt=""></p>'
    //
    // + '<p style="margin-bottom : 0px"><span style="margin-left: 160px; font-size: 16px; ">▶  生物医学制造用户共享实验室</span></p>'
    // + '<p style="margin-bottom : 20px;margin-left: 160px; margin-right: 160px;  "><span style="font-size: 16px;">以精密仪器设计加工为服务核心，提供灵活的实验人员及实验空间组合方式，同时提供舒适的配套环境。</span></p>'
    // +'<p style="margin-bottom : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/xwyxzz.jpg" style="width: 740px; margin-right: 16px;margin-bottom: 16px;" width="760px"  border="0" vspace="0" alt=""></p>'
    //
    // + '<p style="margin-bottom : 0px"><span style="margin-left: 160px; font-size: 16px; ">▶  生物化学用户共享实验室</span></p>'
    // + '<p style="margin-bottom : 20px;margin-left: 160px; margin-right: 160px; "><span style="font-size: 16px;">依据不同空间需求，设计不同规格实验办公条件。实验室设备包含实验台、实验室专用柜、通风柜以及细胞房净化工程、冷室、PCR 室等。</span></p>'
    // +'<p style="margin-bottom : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/swhx.jpg" style="width: 740px; margin-right: 16px;margin-bottom: 16px;" width="760px"  border="0" vspace="0" alt=""></p>'
    //

    //+'<p style="margin-bottom : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/yhgzz2.png" style="width: 760px; margin-right: 16px;margin-bottom: 16px;" width="960px"  border="0" vspace="0" alt=""></p>'

  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
  }
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/pages/kyuser2/en/index.vue